import { EmptyState } from '../ui'
import { useTheme } from '../../hooks/useTheme'
import { useTranslation } from '../../i18n'

export default function SoloLibraryLocked({ pageTitle }: { pageTitle: string }) {
  const theme = useTheme()
  const { translate } = useTranslation()

  return (
    <div className="p-5">
      <header className="mb-6">
        <h1 className="text-2xl font-bold mb-1" style={{ color: theme.text.primary }}>
          {pageTitle}
        </h1>
      </header>
      <EmptyState
        icon="🏃"
        title={translate('subscription.locked.soloOnlyTitle')}
        message={translate('subscription.locked.soloOnlyBody')}
      />
    </div>
  )
}
